import * as React from "react";
import * as ReactDOM from "react-dom";
import { Dialog, DialogType, DialogFooter } from "OfficeFabric/Dialog";
import { Button } from "VSSUI/Button";
import { AttachmentsControlCIEvents } from "WorkItemTracking/Scripts/Utils/WorkItemTrackingCIEventHelper";
import { Attachment } from "WorkItemTracking/Scripts/TFS.WorkItemTracking";
import { KeyCode } from "VSS/Utils/UI";
import { format } from "VSS/Utils/String";
import * as WorkItemTrackingResources from "WorkItemTracking/Scripts/Resources/TFS.Resources.WorkItemTracking";

export interface IDeleteAttachmentDialogProps {
    attachments: Attachment[];
    onClose: (isDeleted: boolean) => void;
}

export class DeleteAttachmentsDialog extends React.Component<IDeleteAttachmentDialogProps> {
    public render() {
        return (
            <div onKeyUp={this._handleKeyUp}>
                <Dialog
                    hidden={false}
                    onDismiss={this._onDismissDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: WorkItemTrackingResources.DeleteAttachmentsDialogTitle
                    }}
                    modalProps={{
                        isBlocking: false
                    }}
                    firstFocusableSelector="ok-button"
                >
                    {this._getDialogTextContent()}
                    <DialogFooter>
                        <Button className="ok-button" primary={true} onClick={this._onOkButtonClicked} text={WorkItemTrackingResources.OK} />
                        <Button onClick={this._onCancelButtonClicked} text={WorkItemTrackingResources.Cancel} />
                    </DialogFooter>
                </Dialog>
            </div>
        );
    }

    private _onDismissDialog = (): void => {
        this._closeDialog(false);
    };

    private _getDialogTextContent(): JSX.Element {
        const { attachments } = this.props;
        let textContent: string;
        if (attachments.length === 1) {
            textContent = format(WorkItemTrackingResources.DeleteSingleAttachmentDialogConfirmationText, attachments[0].getName());
            return <p>{textContent}</p>;
        } else {
            textContent = WorkItemTrackingResources.DeleteAttachmentsDialogConfirmationText;
            const attachmentList = attachments.map(attachment => {
                return <li>{attachment.getName()}</li>;
            });
            return (
                <p>
                    {textContent}
                    <ul>{attachmentList}</ul>
                </p>
            );
        }
    }

    private _onOkButtonClicked = (event: React.MouseEvent<HTMLElement>): void => {
        const { attachments } = this.props;
        // fire the change event only once even if multiple attachments are deleted
        // to prevent invalidate being called on the grid for each attachment
        for (let i = 0; i < attachments.length; i++) {
            const preventEvent: boolean = i !== attachments.length - 1;
            attachments[i].remove([preventEvent] as any);
        }

        AttachmentsControlCIEvents.publishEvent(AttachmentsControlCIEvents.ACTIONS_DELETE, {
            numOfSelectedAttachments: attachments.length
        });

        event.stopPropagation();
        event.preventDefault();

        this._closeDialog(true /* isDeleted */);
    };

    private _onCancelButtonClicked = (event: React.MouseEvent<HTMLElement>): void => {
        event.stopPropagation();
        event.preventDefault();

        this._closeDialog(false /* isDeleted */);
    };

    private _handleKeyUp = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.keyCode === KeyCode.ESCAPE) {
            event.stopPropagation();
            event.preventDefault();

            this._closeDialog(false /* isDeleted */);
        }
    };

    private _closeDialog(isDeleted: boolean): void {
        this.props.onClose(isDeleted);
    }
}

export function showDeleteAttachmentsDialog(container: Element, attachments: Attachment[], onDialogClosed: (isDeleted: boolean) => void): void {
    ReactDOM.render(
        <DeleteAttachmentsDialog
            attachments={attachments}
            onClose={isDeleted => {
                // Closes the dialog by changing the props.
                ReactDOM.unmountComponentAtNode(container);
                onDialogClosed(isDeleted);
            }}
        />,
        container
    );
}
